import React, { useState } from 'react';
import './lazyImage.css';

function LazyImage({ src, alt = 'img', className = '', style = {}, ...props }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <div className={`lazy-image-wrapper ${className}`} style={style}>
      {loading && !error && (<div className={`skeleton-loader ${className}`} style={style}></div>)}

      {!error && (
        <img
          src={src}
          alt={alt}
          className={className}
          style={{ display: loading ? 'none' : 'block', ...style }}
          onLoad={() => setLoading(false)}
          onError={() => {
            setError(true);
            setLoading(false);
          }}
          {...props}
        />
      )}

      {error && (
        <div className={`alt-placeholder ${className}`} style={style}>
          {alt}
        </div>
      )}
    </div>
  );
}

export default LazyImage;
